import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import { CredentialPicker } from '../../../FlowConfigurationInputs/CredentialPicker/CredentialPicker';
import AutomService from '../../../../services/AutomService/AutomService';
import { CheckIfFlowUpdated, isActionValueController } from '../../../../helpers/helper';
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';
import { useRecoilValue, useSetRecoilState } from "recoil";
import { changedFields, initialActions, saveAvailable } from "../../../../recoil-store/recoil-state";

function Connect({ automId, action, variables, setOpenVariable, showAlert, automVersionId }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.ACTIVE-DIRECTORY.CONNECT.';
    const [value, setValue] = useState(0);
    const initialActionsData = useRecoilValue(initialActions);
    const setSaveAvailable = useSetRecoilState(saveAvailable);
    const setChangeFields = useSetRecoilState(changedFields);
    const changedFieldsState = useRecoilValue(changedFields);

    useEffect(() => {
        if (!action.fields.secure) {
            action.fields.secure = { value: 'ldaps' };
            setValue(0);
        } else {
            setValue(action.fields.secure.value === 'ldaps' ? 0 : 1)
        }
    }, [action.id]);

    const handleClick = async () => {
        let res = isActionValueController(action.fields);
        if (res.indexOf(false) === -1) {
            action.automId = automId;
            action.automVersionId = automVersionId;
            let response = await AutomService.runAction(action);
            if (response) { showAlert(t('FLOW-MESSAGES.LIBRARY.' + response.message), response.status); }
        }
        else { showAlert(t('ACTIVE-DIRECTORY.NOT-NULL'), false); }
    }

    const handleChange = (newValue) => {
        let newValueType;
        if (newValue === 0) {
            newValueType = "ldaps";
            action.fields.secure.value = 'ldaps';
        } else {
            newValueType = "ldap";
            action.fields.secure.value = 'ldap';
        }
        setValue(newValue);
        const field = initialActionsData[action.id]?.fields["secure"];
        if (field) {
            const oldValue = field.value
            CheckIfFlowUpdated("secure", action, oldValue, newValueType, setSaveAvailable, setChangeFields, changedFieldsState);
        } else {
            setSaveAvailable(true);
        }


    };

    return (
        <div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'SECURE')} />
                <div className="condition-tabs" style={{ marginBottom: '0px' }}>
                    <button
                        className={`f-s-11 ${value === 0 ? 'condition-active' : ''}`}
                        onClick={() => handleChange(0)}>
                        Ldaps
                    </button>
                    <button
                        className={`f-s-11 ${value === 1 ? 'condition-active' : ''}`}
                        onClick={() => handleChange(1)}>
                        Ldap
                    </button>
                </div>
                {
                    value === 1 &&
                    <small className="conf-field-desc">{t(label + 'LDAP-DESC')}</small>
                }
            </div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'PATH')} is_required />
                <TextInput action={action} inputName="path" variables={variables} setOpenVariable={setOpenVariable} isRequired
                    fieldType='string' displayName={t(label + 'PATH')} hideRequired />
                <small className="conf-field-desc">ldap.example.com:{value === 1 ? '636' : '389'}</small>
            </div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'USER')} is_required />
                <CredentialPicker action={action} inputName="loginUser" variables={variables} setOpenVariable={setOpenVariable} isRequired hideRequired />
            </div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'PASSWORD')} is_required />
                <CredentialPicker action={action} inputName="loginPassword" variables={variables} setOpenVariable={setOpenVariable} isRequired isPassword={true} hideRequired />
            </div>
            <div className="conf-field-container">
                <FieldLabel name={"Base Path"} is_required />
                <TextInput action={action} inputName="baseDn" variables={variables} setOpenVariable={setOpenVariable} isRequired
                    fieldType='string' displayName={'Base Path'} hideRequired />
                <small className="conf-field-desc">dc=autommate,dc=com</small>
            </div>
            <button className="form-button" onClick={() => handleClick()}>Test Connection</button>
        </div>
    )
}

export default Connect;
